import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from '../routes/PathLink'
import { Table } from "../components/ui/table";
import { Pagination, Select } from "antd";
import { amount_format, cleanCompanyName } from "../components/config/Common";

const CompanyTable = (props) => {	
    const {data, pageSize, isLoading, paginatorInfo, totalPages} = props
    //console.log('data props===',data)

    const skeleton = Array.from({ length: pageSize }, (_, i) => ({
    id: `sk-${i}`,
    _isSkeleton: true
    }));
    

    const columns = [
    
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      width: 150,
      fixed: 'left',
      className: 'column-bg',
      render:(name,record) =>(
         <div
          className="overflow-hidden truncate whitespace-nowrap text-wrap" >
           {record?.company_name && record?.company_name != '' ?
            (<Link className="text-accent" to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${record.symbol}`}><span className="text-sm">{cleanCompanyName(record?.company_name)}</span></Link>)
            :(null)
          }          
        </div>
      )
    },
    {
      title: <div className='cursor-pointer' title='Current Market Price'>CMP <span className="text-xs text-gray-500">Rs</span> </div>,
      dataIndex: 'nse_price',
      key: 'nse_price',
      align: 'left',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div>{amount_format(record?.nse_price)}</div>
              }
              </>
            )
    },
    {
      title: <div className='cursor-pointer' title='Price to Earnings Ratio'>P/E</div>,
      dataIndex: 'pe',
      key: 'pe',
      align: 'left',
      width: 100,
    },
    {
      title: <div className='cursor-pointer' title='Market Capitalization'>Mar Cap <span className="text-xs text-gray-500">Rs.Cr.</span></div>,
      dataIndex: 'market_cap',
      key: 'market_cap',
      align: 'left',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div>{amount_format(record?.market_cap)}</div>
              }
              </>
            )
    },
    {
      title: <div className='cursor-pointer' title='Dividend Yield'>Div Yld <span className="text-xs text-gray-500">%</span></div>,
      dataIndex: 'dividend_yield',
      key: 'dividend_yield',
      align: 'left',
      width: 100,
    },
    {
      title: <div className='cursor-pointer' title='Net Profit Latest Quarter'>NP Qtr <span className="text-xs text-gray-500">Rs.Cr.</span></div>,
      dataIndex: 'netprofit_lst_qtr',
      key: 'netprofit_lst_qtr',
      align: 'left',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div>{amount_format(record?.netprofit_lst_qtr)}</div>
              }
              </>
            )
    },
    {
      title: <div className='cursor-pointer' title='YOY Quarterly Profit Growth'>Qtr Profit Var <span className="text-xs text-gray-500">%</span></div>,
      dataIndex: 'yoy_qrt_profit_growth',
      key: 'yoy_qrt_profit_growth',
      align: 'left',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div className={record?.yoy_qrt_profit_growth < 0 ? 'text-red-500' :record?.yoy_qrt_profit_growth > 0 && 'text-green-500'}>{record?.yoy_qrt_profit_growth}{record?.yoy_qrt_profit_growth ? <>%</>:null}</div>
              }
              </>
            )
    },
    {
      title: <div className='cursor-pointer' title='Sales Latest Quarter'>Sales Qtr <span className="text-xs text-gray-500">Rs.Cr.</span></div>,
      dataIndex: 'sales_latest_quarter',
      key: 'sales_latest_quarter',
      align: 'left',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div>{amount_format(record?.sales_latest_quarter)}</div>
              }
              </>
            )
    },
    {
      title: <div className='cursor-pointer' title='YOY Quarterly Sales Growth'>Qtr Sales Var <span className="text-xs text-gray-500">%</span></div>,
      dataIndex: 'qtrsalesvar',
      key: 'qtrsalesvar',
      align: 'left',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div className={record?.yoy_qrt_sales_growth < 0 ? 'text-red-500' :record?.yoy_qrt_sales_growth > 0 && 'text-green-500'}>{record?.yoy_qrt_sales_growth}{record?.yoy_qrt_sales_growth ? <>%</>:null}</div>
              }
              </>
            )
    },
    {
      title: <div className='cursor-pointer' title='Return on Capital Employed'>ROCE <span className="text-xs text-gray-500">%</span></div>,
      dataIndex: 'roce',
      key: 'roce',
      align: 'left',
      width: 100,
    },
  
];

    const modifiedData = insertHeaderEvery(data || [], columns, 10);

    function insertHeaderEvery(result, columns, interval = 20) {
    const updated = [];

    result.forEach((row, index) => {
        // Insert header row before row number (multiple of interval)
        if (index % interval === 0 && index !== 0) {
        updated.push({ ...columns.reduce((acc, col) => {
            acc[col.dataIndex] = col.title;
            return acc;
        }, {}), _isHeader: true });
        }
        updated.push(row);
    });
    
    return updated;
    }

    const onPagination = (current) => {
        //console.log("current Page",current);
        props.onPagination(current);
    }
    const onPageSize = (value) => {
        props.onPageSize(value)
    }

    return (
        <>
            {paginatorInfo &&<div className="mt-5 text-sm text-gray-500">
                  {paginatorInfo?.total} results found: Showing page {paginatorInfo?.currentPage} of {totalPages}
                </div>}
            <div className="my-6 overflow-hidden rounded shadow">
            <Table            
                columns={columns}
                rowKey="id"
                data={isLoading ? skeleton : data}
                scroll={{ x: 900 }}
                rowClassName={(record, index) => {
                    if (record._isSkeleton) {
                        // Animate only alternate skeleton rows (even rows)
                        return index % 2 === 0
                        ? "skeleton-row pulse-row"
                        : "skeleton-row-odd";
                    }

                    if (record._isHeader) return "repeat-header";

                    return "";
                }}
            />
            </div>
            <div className="w-full flex justify-start mb-5">
                {!!paginatorInfo?.total && ( 
                <div className="w-full flex items-left justify-between flex-wrap">
                    <div>
                    <Pagination
                    total={paginatorInfo.total}
                    current={paginatorInfo.currentPage}
                    pageSize={paginatorInfo.perPage}
                    onChange={onPagination}
                    showSizeChanger={false}
                    className="flex-wrap"
                    />
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="px-5 text-sm text-gray-500">Results Per Page</div>
                        <Select
                            value={pageSize}
                            onChange={onPageSize}
                            options={[
                                { value: 10, label: "10 rows" },
                                { value: 25, label: "25 rows" },
                                { value: 50, label: "50 rows" },
                                { value: 100, label: "100 rows" },
                                
                            ]}
                            style={{ width: 130 }}
                        />
                    </div>
                </div>
                )} 
            </div>
        </>    
    )
}

export default CompanyTable;